import { FunctionComponent, useEffect } from 'react';
import { GridBag, Div } from '@gaiads/telia-react-component-library';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import { useToBreakpoint } from '@cdaas/reusable-components-daas';

import CheckoutDetails from './CheckoutDetails/CheckoutDetails';
import CheckoutSummary from './CheckoutSummary/CheckoutSummary';
import CheckoutDelivery from './CheckoutDelivery/CheckoutDelivery';
import CheckoutStepper from './CheckoutStepper/CheckoutStepper';
import CheckoutProductCart from './CheckoutProductCart/CheckoutProductCart';
import WebshopCheckout from './WebshopCheckout/WebshopCheckout';

import classes from './Checkout.module.scss';
import { checkIsSelectedOrganizationOwn } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/reducers';
import { shopResetProduct } from '../../../store/actions';

interface CheckoutProps {}

// TODO: import from TRCL
const MOBILE_BREAKPOINT = 1080;

const Checkout: FunctionComponent<CheckoutProps> = () => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const isMobile = useToBreakpoint(MOBILE_BREAKPOINT);

  const ownOrganizationId = useSelector((state: RootState) => state.authentication.user?.organization?.id);
  const selectedOrganizationId = useSelector((state: RootState) => state.authentication.selectedOrganization?.id);

  useEffect(() => {
    return () => {
      if (!checkIsSelectedOrganizationOwn(ownOrganizationId, selectedOrganizationId)) {
        dispatch(shopResetProduct());
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GridBag showGridLines noGutter>
      <GridBag.Item md={12} lg={7} padding={{ horizontal: 'md' }}>
        <Div margin={{ vertical: 'xlg' }}>
          <CheckoutStepper />
        </Div>
        <Switch>
          <Route exact path={`${path}`} render={() => <CheckoutDetails isMobile={isMobile} />} />
          <Route path={`${path}/summary`} render={() => <CheckoutSummary isMobile={isMobile} />} />
          <Route path={`${path}/delivery`} render={() => <CheckoutDelivery isMobile={isMobile} />} />
          <Route path={`${path}/:stateId`} render={() => <WebshopCheckout />} />
          <Redirect to="/home" />
        </Switch>
      </GridBag.Item>
      {!isMobile ? (
        <GridBag.Item lg={5} className={classes['checkout__product-cart-column']}>
          <CheckoutProductCart />
        </GridBag.Item>
      ) : undefined}
    </GridBag>
  );
};

export default Checkout;
